import './svg-map.css';
import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';

import Shape from './components/Shape';
import PlotLabel from './components/PlotLabel';

const getPlotNumberById = (id, plotNumbers) => plotNumbers.find(({ id: plotId }) => id === plotId);

export default function SvgMap({
	shapes,
	plotNumbers,
	mapSize,
	svgSize,
	backgroundImageSrc,
	handleShapeClick,
	handleOutsidePlotClick,
	onSvgBoundingBoxChange,
	displayLotNumbers
}) {
	const [plotSvgLabels, setPlotSvgLabels] = useState([]);
	const refSvg = useRef(null);

	useEffect(() => {
		if (refSvg && refSvg.current && typeof onSvgBoundingBoxChange === 'function') {
			onSvgBoundingBoxChange(refSvg.current.getBBox());
		}
	}, [refSvg, backgroundImageSrc]);

	useEffect(() => {
		if (refSvg.current !== null) {
			let childrenData = [];

			Object.values(refSvg.current.children).forEach(child => {
				childrenData.push({
					id: parseInt(child.getAttribute('id'), 10),
					coordinates: child.getBBox()
				});
			});

			setPlotSvgLabels(shapes.map(shape => {
				let coordinates = null;
				childrenData.forEach(svgElement => {
					if (svgElement.id === shape.id) {
						coordinates = svgElement.coordinates;
					}
				});

				const plotNumber = getPlotNumberById(shape.id, plotNumbers);
				return {
					id: shape.id,
					label: plotNumber ? plotNumber.number : null,
					isHighlighted: shape.isHighlighted,
					coordinates
				};
			}));
		}
	}, [refSvg, shapes]);

	return (
		<div class="svg-map-container" style={`background-image: url('${backgroundImageSrc}'); width: ${mapSize.width}px; height: ${mapSize.height}px`} onClick={handleOutsidePlotClick}>
			{Array.isArray(shapes) && shapes.length > 0 ?
				<svg
					ref={refSvg}
					class="svg-map-shapes-container"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlnsXlink="http://www.w3.org/1999/xlink"
					x="0px"
					y="0px"
					xmlSpace="preserve"
					viewBox={'0 0 ' + svgSize.width + ' ' + svgSize.height}
					width={svgSize.width}
					height={svgSize.height}
				>
					{
						shapes.map(shape => (
							<Shape
								{...shape}
								handleClick={handleShapeClick}
							/>
						))
					}
					{
						displayLotNumbers && plotSvgLabels.length > 0 &&
						<g>
							{plotSvgLabels.map(plotLabel => (
								<PlotLabel
									{...plotLabel}
								/>
							))}
						</g>
					}
				</svg>
				: ''}
		</div>
	);
}
